import { render, staticRenderFns } from "./VerticalKeyValue.vue?vue&type=template&id=fb8ce74c&scoped=true&"
import script from "./VerticalKeyValue.vue?vue&type=script&lang=js&"
export * from "./VerticalKeyValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8ce74c",
  null
  
)

export default component.exports